module.exports = __webpack_public_path__ + "static/dancing-911e35c64182a9bffc17d35f04daec39.gif";